﻿(function () {

    var sliders = document.querySelectorAll('.popular-categories-slider');
    var windowWidth = window.innerWidth;

    for (var i = 0; i < sliders.length; i++) {

        var glide = new Glide(sliders[i], {

            type: "slider",
            perView: 5,
            gap: 0,
            bound: true,
            rewind: false,
            perSwipe: '|',

            peek: {
                before: 0,
                after: 80
            },

            breakpoints: {
                1199: {
                    perView: 4,
                    peek: { before: 0, after: 80 }
                },
                991: {
                    perView: 3,
                    peek: { before: 0, after: 70 }
                },
                575: {
                    perView: 2,
                    peek: { before: 0, after: 60 }
                },
                360: {
                    perView: 1,
                    peek: { before: 0, after: 60 }
                }
            }
        });

        window.addEventListener("resize", function () {
            if (window.innerWidth != windowWidth) {
                glide.go('<<');
                windowWidth = window.innerWidth;
            }
        });

        glide.mount();
    }

})();